/*
 * @Author: alex
 * @Date: 2022-08-27 14:57:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-17 10:13:24
 * @Description:
 * Copyright (c) 2022 by piesat, All Rights Reserved.
 */

import type * as ol from 'ol'
import { LifecycleState } from '@vmap/core'
import type { Lifecycle } from '@vmap/core'
import { TypeEvented } from '@vmap/core'

export interface MapTool extends Lifecycle {
  /**
   * 清除tool状态 数据等
   */
  clear: () => void
}

/**
 * 抽象基类
 */
export abstract class BaseMapTool<T> extends TypeEvented<T> implements MapTool {
  /**
   * 地图对象
   */
  protected map: ol.Map

  /**
   * 工具状态
   */
  protected state: LifecycleState = LifecycleState.IDLE

  constructor(map: ol.Map) {
    super()
    this.map = map
  }

  protected abstract startInternal(): void

  protected abstract stopInternal(): void

  clear() {
    this.state = LifecycleState.IDLE
  }

  start() {
    this.startInternal()
    if (this.state === LifecycleState.IDLE) {
      this.state = LifecycleState.START
    }
  }

  stop() {
    this.stopInternal()
    if (this.state !== LifecycleState.ERROR) {
      this.state = LifecycleState.STOP
    }
  }

  getLifecycleState() {
    return this.state
  }
}
